import Apis from './apis'
export default Apis
